<template>
  <section>
    <div class="usercontainer clearfix">
      <div class>
        <div class="user-cont">
          <div class="num_text">
            <div class="flex text">
              <div class="row">
                <div class="cont flex">
                  <div class="fieldname title pinjiatype">反馈标题：</div>
                  <el-input placeholder="请输入内容" v-model="title" clearable style="width: 300px;"></el-input>
                </div>
              </div>
              <div class="row" style="margin-left:20px">
                <div class="cont flex">
                  <div class="fieldname title pinjiatype">反馈内容：</div>
                  <textarea
                    class="form-control"
                    rows="4"
                    v-model="content "
                    style="width: 300px;padding:6px;"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="title flex" style="margin-top:30px;">
            <div class="fieldname title pinjiatype">上传图片</div>
            <div class="cont">
              <el-upload
                multiple
                :limit="limit"
                :action="uploadimg"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-change="filechange"
                :on-remove="handleRemove"
                :on-exceed="exceed"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible" size="tiny">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class style="margin-top:80px;">
      <div class="fieldname"></div>
      <div class="cont center">
        <el-button type="primary" @click="submitpinjia" class="mb20">提交</el-button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Pinjia",
  data() {
    return {
      limit: 6,
      title: "",
      uploadimg: sessionStorage.baseUrl + "app/file/upload",
      content: "",
      ishide: true,
      dialogImageUrl: "",
      fileList: [],
      orderDetail: {},
      dialogVisible: false
    };
  },
  props: {},
  methods: {
    handleRemove(file, fileList) {
      // console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
      // console.log(this.dialogImageUrl)
    },
    filechange(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList;
    },
    exceed(files, fileList) {
      this.$message.error(`最多只能上传${this.limit}张图片！`);
    },
    async submitpinjia() {
      let photos = this.fileList.map(item => {
        if (item.response.code == 0) return item.response.msg;
      });
      let data = {
        content: this.content,
        photos,type:1,act:"add",
        title: this.title
      };
      let res = await this.$fetch("member/feedback", {
        body: data
      });
      if (res) {
        this.$message({
          message: "提交成功",
          type: "success"
        });
        this.$emit('fatherMethod');
      }
    }
  },
  mounted() {
    // this.getOrderDetail();
  }
};
</script>

<style lang='scss' scoped>
.user-cont {
  align-items: flex-start;
  .text {
    align-content: flex-start;
  }
}
.pinjiatype {
  margin: 0;
  padding: 0;
  width: 100px;
}
.row {
  margin: 20px 0;
}

.cont {
  margin: 10px 0;
  .el-rate__item {
    i {
      font-size: 30px;
    }
  }
}
.num_text {
  display: flex;
  width: 300px;
  flex-direction: column;
  justify-content: space-around;
  .row {
    margin: 0;
  }
}
.img {
  width: 200px;
  height: 200px;
  // a {
  //   display: inline-block;
  //   width: 100%;
  //   height: 100%;
  img {
    width: 100%;
    height: 100%;
  }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/advice.vue